import { render, staticRenderFns } from "./CartaoDatas.vue?vue&type=template&id=205a9c36&scoped=true"
import script from "./CartaoDatas.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDatas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDatas.vue?vue&type=style&index=0&id=205a9c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205a9c36",
  null
  
)

export default component.exports